<template>
  <button
    class="text-xl font-medium text-brand text-nowrap"
    @click="handleCreateApiKey"
  >
    + {{ $t('b2b|header|button|create') }}
  </button>

  <modal-api-key-success-create
    v-model="showSuccessApiKey"
    @onUpdate="openUpdateApiKey"
  />

  <modal-api-key-create
    v-model="showCreateApiKey"
    :is-update="isUpdateApiKey"
    @onSubmit="submitCreateApiKey"
  />
</template>

<script setup>
import { ref } from 'vue'

import ModalApiKeySuccessCreate from '@/widgets/ModalApiKeys/ui/ModalApiKeySuccessCreate.vue'
import ModalApiKeyCreate from '@/widgets/ModalApiKeys/ui/ModalApiKeyCreate.vue'

const showCreateApiKey = ref(false)
const showSuccessApiKey = ref(false)

const isUpdateApiKey = ref(false)

function submitCreateApiKey() {
  showCreateApiKey.value = false
  showSuccessApiKey.value = true
}

function handleCreateApiKey() {
  showCreateApiKey.value = true
}

function openUpdateApiKey() {
  showCreateApiKey.value = true
  isUpdateApiKey.value = true
  showSuccessApiKey.value = false
}
</script>
